import $ from 'jquery';
import counterUp from 'counterup2';

$(function () {

    $('.counter-value').each(function () {


        const duration = $(this).data('duration') || 2000;

        const callback = (entries, observer) => {
            entries.forEach(entry => {
                const element = entry.target
                if (entry.isIntersecting) {
                    observer.unobserve(element);
                    counterUp(element, {
                        duration: duration,
                        delay: 20,
                    })
                }
            })
        }

        const observer = new IntersectionObserver(callback, {
            threshold: 0.3,
        })
        observer.observe($(this)[0])

    })

});
